<template>
    <div class="studentPortal">
      <Header :view="ViewMode" @alterar-valor="alterarValor" />
      <main class="student-portal-main-content">
        <RouterView />
      </main>
      
      <Footer :view="ViewMode" />
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex'
  
  import Header from '@/components/Student/Dashboard_Unique/Header/Header'
  import Footer from '@/components/Student/Dashboard_Unique/Footer/Footer'
  import apiWebsite from '@/utils/portal/website'
  
  export default {
    data() {
      return {
        ViewMode: false,
        dataCourses: null,
      }
    },
    computed: {
      ...mapState(['token', 'dark']),
      ...mapState('portal', ['dataWebsitePortal2']),
    },
    methods: {
      ...mapActions(['toggleDarkMode']),
      ...mapActions('portal', ['storeDataWebsitePortal2']),
  
      alterarValor(novoValor) {
        this.toggleDarkMode({ dark: !this.dark })
      },
  
      async getDataWebsite() {
        try {
          const response = await apiWebsite.getDataWebsite(this.token)
          console.log('Dados da API:', response)
          this.storeDataWebsitePortal2({dataWebsitePortal2: response})

        } catch (error) {
          console.error('Erro ao carregar dados do site:', error)
        }
      },
    },
    watch: {
      ViewMode(novoValor) {
        this.ViewMode = novoValor
      },
    },
    components: {
      Header,
      Footer,
    },
    created() {
      this.getDataWebsite()
    },
  }
  </script>
  
  <style scoped>
  .studentPortal {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
  }
  
  .student-portal-main-content {
    flex: 1 1 auto;
  }
  
  .student-portal-main-content > div {
    height: 100%;
  }
  </style>
  